/* Little Cousin — motion layer.
   CSS + IntersectionObserver only. No motion library, by decision (DL-013,
   Modernite Dial level 2). Everything degrades to a static, readable page
   when JS is off or when the visitor prefers reduced motion. */

(function () {
  var reduce =
    window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---- reveal on scroll -------------------------------------------- */
  var reveals = document.querySelectorAll('.lc-reveal');

  if (reduce || !('IntersectionObserver' in window)) {
    Array.prototype.forEach.call(reveals, function (el) {
      el.classList.add('is-visible');
    });
  } else {
    /* threshold 0, not 0.08. A section taller than the viewport can never show
       8% of itself early enough, so tall blocks stayed invisible well after
       they had entered the screen. With threshold 0 the reveal fires the moment
       any part of the element crosses the line, whatever its height. */
    var io = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          entry.target.classList.add('is-visible');
          io.unobserve(entry.target);
        });
      },
      { rootMargin: '0px 0px -8% 0px', threshold: 0 }
    );

    Array.prototype.forEach.call(reveals, function (el, i) {
      // Stagger siblings so a row of cards arrives in sequence, not as a block.
      el.style.transitionDelay = Math.min(i % 4, 3) * 70 + 'ms';
      io.observe(el);
    });
  }

  /* ---- scroll-tied check bands ------------------------------------- */
  var bands = document.querySelectorAll('.lc-check--tied');
  if (reduce || !bands.length) return;

  var ticking = false;

  function shift() {
    Array.prototype.forEach.call(bands, function (band) {
      var rect = band.getBoundingClientRect();
      var progress = 1 - (rect.top + rect.height) / (window.innerHeight + rect.height);
      band.style.setProperty('--lc-shift', (progress * 52).toFixed(2));
    });
    ticking = false;
  }

  window.addEventListener(
    'scroll',
    function () {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(shift);
    },
    { passive: true }
  );

  shift();
})();
